import React, { useEffect, useState } from "react";
import { BiCopy, BiData, BiLineChart, BiPieChart, BiTransfer } from "react-icons/bi";
import { BsGear, BsInfo } from "react-icons/bs";
import { useNavigate, useParams } from "react-router-dom";
import { TubeGeometry } from "three";
import UsageAnalytics from "./Analytics/UsageAnalytics";
import { TbGalaxy } from "react-icons/tb";
import InfoModal from "./Info/InfoModa";
import { IoMdTrendingUp } from "react-icons/io";
import Scaling from "./Scaling/Scaling";

const OpenCluster = () => {
    const user_id = sessionStorage.getItem("user_id");
    const { project_id, clus_id, link_page } = useParams()
    const navigate = useNavigate()
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false);
    const [copied, setCopied] = useState(false)
    const [clusterName, setClusterName] = useState(null)
    const [metrics, setMetrics] = useState({})
    const [costMetrics, setCostMetrics] = useState(null)
    const [openInfo, setOpenInfo] = useState(false)

    const changePage = (page) => {
        navigate(`/project_panel/${project_id}/clusters/${clus_id}/${page}`)
    }

    const goBack = () => {
        navigate(`/project_panel/${project_id}/clusters`)
    }

    const fetchRecords = async () => {
        try {
            const response = await fetch("https://backend.erioon.com/get_specific_cluster_information", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id, clus_id }),
            });

            if (response.ok) {
                const result = await response.json();
                const data = result.cluster_data || {};
                const metrics = result.metrics || {};
                const costs = result.current_cost || 0;
                setRecords(data);
                setMetrics(metrics)
                setCostMetrics(costs)
                setClusterName(data.k8sname)
                setError(false);
                setLoading(false);
                return data.status;
            } else {
                setError(true);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
            setError(true);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (user_id) {
            fetchRecords()
        } else {
            setError(true);
            setLoading(false);
        }
    }, []);



    const handleCopyClick = () => {
        navigator.clipboard.writeText(clus_id);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div>
            <div className="new_section_main_view">
                <p className="new_section_main_view_title">
                    <i className="fa-solid fa-chevron-left" onClick={goBack}></i> <span className={`${clusterName ? "new_section_main_view_title_span" : "new_section_main_view_title_span_loading"}`}>{clusterName}</span>
                    <span className={`${clus_id ? "new_section_main_view_title_db_id" : "new_section_main_view_title_db_id_loading"}`}>
                        {clus_id}
                        {clus_id && (
                            <i onClick={handleCopyClick}>
                                {copied ? (
                                    <i className="fa-solid fa-check"></i>
                                ) : (
                                    <BiCopy />
                                )}
                            </i>
                        )}
                    </span>
                </p>
                <p className="new_section_main_view_subtitle">
                    All the resources you need in a single page.
                </p>
                {!loading && (
                    <></>
                )}

                <div className="open_db_main_view">
                    <div className="open_db_main_navbar">
                        <div className="open_db_main_navbar_cont">
                            <button className={`open_db_main_btn ${link_page === "analytics" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("analytics")}><BiLineChart /> Analytics</button>
                            <button className={`open_db_main_btn ${link_page === "scaling" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("scaling")}><IoMdTrendingUp /> Scaling</button>
                        </div>
                        <div className="open_db_main_navbar_cont">
                            <button className="open_db_main_btn" onClick={() => setOpenInfo(true)}><i className="fa-solid fa-info"></i> Info</button>
                        </div>
                    </div>
                    {loading ? (
                        <div className="loading_logo_erioon">
                            <p className="loading_logo_erioon_icon"><i><TbGalaxy /></i></p>
                        </div>
                    ) : (
                        <>
                            {link_page === "analytics" ? (
                                <UsageAnalytics metrics={metrics} records={records} costMetrics={costMetrics} fetchRecords={fetchRecords}/>
                            ) :link_page === "scaling" ? (
                                <Scaling  metrics={metrics} records={records} costMetrics={costMetrics} fetchRecords={fetchRecords}/>
                            ):(
                                <></>
                            )}
                        </>
                    )}

                </div>
            </div>

            <InfoModal
                show={openInfo}
                handleClose={() => setOpenInfo(false)}
                records={records}
            />
        </div>
    )
}

export default OpenCluster